/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CardProductionQuery = {
    /**
     * Filter by card production number
     */
    productionNumber?: number;
    /**
     * Card production cards type. "EMPLOYEE", "EXPRESS" etc
     */
    productionCardTypes?: Array<'PERSONAL' | 'EXPRESS' | 'PORTABLE' | 'RECLAMATION' | 'EMPLOYEE'>;
    /**
     * Card production type. "PERSONALIZED or NOT_PERSONALIZED"
     */
    productionType: CardProductionQuery.productionType;
    /**
     * Employee who create card production.
     */
    employeeName?: string;
    /**
     * Filter by card production states.
     */
    state?: CardProductionQuery.state;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    /**
     * Sort by. Default: id
     */
    sortBy?: string;
    /**
     * Sort order descendent. Default: true
     */
    sortDesc?: boolean;
    /**
     * Sort with locale. Default: sk
     */
    sortLocale?: string;
    /**
     * Page Size. Default: 25
     */
    limit?: number;
    /**
     * Offsetting x items. Default: 0
     */
    offset?: number;
    /**
     * Filter by date within date range. Type: 'DATE'
     */
    date?: string;
};
export namespace CardProductionQuery {
    /**
     * Card production type. "PERSONALIZED or NOT_PERSONALIZED"
     */
    export enum productionType {
        PERSONAL = 'PERSONAL',
        NOT_PERSONAL = 'NOT_PERSONAL',
    }
    /**
     * Filter by card production states.
     */
    export enum state {
        IN_PROGRESS = 'IN_PROGRESS',
        PROCESSED = 'PROCESSED',
    }
}

